export default "__VITE_ASSET__63ea9471__"